import { type CoreBooking } from '@flecto/types'
import { useBookingPaymentDepositStatus } from '@flecto/utils'

import { Badge, type BadgeProps } from '..'

export type BadgeBookingPaymentDepositStatusProps = BadgeProps & {
  booking?: CoreBooking
}

export function BadgeBookingPaymentDepositStatus({
  booking,
  ...props
}: BadgeBookingPaymentDepositStatusProps) {
  const { label, color } = useBookingPaymentDepositStatus({ booking })

  return (
    <Badge {...props} color={color}>
      {label}
    </Badge>
  )
}
